module.exports = __webpack_public_path__ + "img/logo_wechat.6a99804b.svg";